import React from 'react';
import { cnTumbler } from '../Tumbler';
export var TumblerControl = function (_a) {
    var id = _a.id, innerRef = _a.innerRef, checked = _a.checked, name = _a.name, onChange = _a.onChange, required = _a.required;
    return (React.createElement("input", { id: id, hidden: true, ref: innerRef, className: cnTumbler('Control'), name: name, checked: checked, value: String(checked), type: "checkbox", autoComplete: "off", onChange: onChange, required: required }));
};
